import { Routes } from '@angular/router';

import { taskManagerUrlMatcher } from './task-manager-url-matcher';
import { taskTypeRouteGuard } from './task-type-route.guard';

/** Child routes of `tasks`, see `taskManagerUrlMatcher` for the urls the page handles */
export const taskManagerRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'reader',
  },
  {
    // One route for all the task types, so the page is not created again when the task type is switched or a task is opened
    matcher: taskManagerUrlMatcher,
    // upload tasks need the case_uploader feature
    canActivate: [taskTypeRouteGuard],
    loadComponent: () => import('./task-manager.component').then((m) => m.TaskManagerComponent),
  },
];
